module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.records.length === 0 && !_vm.loading) ? _c('empty-reminder') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "phone-records"
    }
  }, _vm._l((_vm.records), function(record) {
    return _c('div', {
      staticClass: "phone-records-list"
    }, [_c('p', {
      staticClass: "description"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('yourFriends')) + " " + _vm._s(record.nickname) + " " + _vm._s(_vm.$t('bought')) + "\n        " + _vm._s(record.package_device_count) + " " + _vm._s(_vm.$tc('devices', record.package_device_count)) + "\n        " + _vm._s(_vm.$t(record.package_name)) + _vm._s(_vm.$t('plan')) + "\n        "), (record.status === 'cancelled') ? [_vm._v(_vm._s(_vm.$t('refunded')))] : _vm._e()], 2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('amount')) + _vm._s(_vm.$t(':'))), _c('span', {
      class: {
        'cancelled': record.status === 'cancelled'
      }
    }, [_vm._v(_vm._s(record.award_days) + " " + _vm._s(_vm.$tc('days', record.award_days)))])]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.$t('time')) + _vm._s(_vm.$t(':')) + _vm._s(_vm._f("createFormatTime")(record.created_at, record.created_at)))])])
  }), 0), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('back-to-top'), _vm._v(" "), _c('load-more', {
    attrs: {
      "current-page": _vm.currentPage,
      "total-page": _vm.totalPage,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAwardRecords($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f63eb28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/affiliate/rewardRecords/RewardRecordsM.vue
// module id = 1373
// module chunks = 1